import { Edit } from '@mui/icons-material';
import { Button, Link } from '@mui/material';
import React from 'react';
import { buttons, Colors } from '../../../utils/theme';

interface IProps {
  id: string;
  onClick: () => void;
  disabled?: boolean;
  editButtonColor?: string;
}

const EditButton: React.FunctionComponent<IProps> = ({
  id,
  onClick,
  disabled = false,
  editButtonColor = Colors.skyBlue
}) => {
  return (
    <Button
      id={id}
      data-testid={id}
      component={Link}
      onClick={onClick}
      disabled={disabled}
      sx={{ ...buttons.edit }}
    >
      <Edit
        sx={{
          fontSize: 'medium',
          color: editButtonColor,
          marginRight: '3px'
        }}
      />
      EDIT
    </Button>
  );
};

export default EditButton;
